@let blok = block();
<ng-template #content>
  <p class="m-0 text-primary text-md md:text-3xl font-bold group-hover:text-white ">
    {{ blok.textContent }}
  </p>
  <span
    class="flex w-10 h-10 rounded-full bg-primary group-hover:bg-white justify-center items-center p-1">
    <mat-icon
      aria-hidden="false"
      aria-label="Icon"
      class="!block !h-16 !w-auto !max-w-16"
      svgIcon="right_arrow"/>
  </span>
</ng-template>

@if(blok.link?.linktype && (blok.link?.url || blok.link?.cached_url)) {
  @switch (blok.link?.linktype) {
    @case ('url') {
      <a  (click)="click()($event)"
        class="button-with-dot group flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot bg-transparent justify-center items-center gap-6 hover:border hover:border-solid hover:border-primary hover:bg-primary py-2 pl-6 md:pl-12 pr-2 whitespace-nowrap"
        [href]="sanitizedLink() | desanitizeSlash"
        [target]="blok.link?.target || ''"
        [rel]="blok.link?.target === '_blank' ? 'noopener noreferrer' : undefined">
        <ng-container *ngTemplateOutlet="content">
        </ng-container>
      </a>
    }
    @case ('story') {
      <a  (click)="click()($event)"
        class="button-with-dot group flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot bg-transparent justify-center items-center gap-6 hover:border hover:border-solid hover:border-primary hover:bg-primary py-2 pl-6 md:pl-12 pr-2 whitespace-nowrap"
        [routerLink]="blok.link?.cached_url | sbRouterLink | cachedUrlResolver"
        [fragment]="blok.link?.anchor"
        [target]="blok.link?.target || ''">
        <ng-container *ngTemplateOutlet="content">
        </ng-container>
      </a>
    }
    @case ('email') {
      <a  (click)="click()($event)"
        class="button-with-dot group flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot bg-transparent justify-center items-center gap-6 hover:border hover:border-solid hover:border-primary hover:bg-primary py-2 pl-6 md:pl-12 pr-2 whitespace-nowrap"
        [href]="'mailto:' + sanitizedLink() | desanitizeSlash">
        <ng-container *ngTemplateOutlet="content">
        </ng-container>
      </a>
    }
    @case ('asset') {
      <a (click)="click()($event)"
        class="button-with-dot group flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot bg-transparent justify-center items-center gap-6 hover:border hover:border-solid hover:border-primary hover:bg-primary py-2 pl-6 md:pl-12 pr-2 whitespace-nowrap"
        [href]="sanitizedLink() | desanitizeSlash"
        [target]="blok.link?.target || ''">
        <ng-container *ngTemplateOutlet="content">
        </ng-container>
      </a>
    }
  }
} @else {
  <button
    class="button-with-dot group flex flex-shrink-0 rounded-full border border-solid border-secondary p-button-with-dot bg-transparent justify-center items-center gap-6 hover:border hover:border-solid hover:border-primary hover:bg-primary py-2 pl-6 md:pl-12 pr-2 whitespace-nowrap"
    (click)="click()($event)"
    [disabled]="blok.disabled">
    <ng-container *ngTemplateOutlet="content">
    </ng-container>
  </button>
}
